import React, { useState, useEffect, useCallback, memo } from 'react'
import { Col, Container, Input, InputGroup, Card, CardBody, Row, Spinner ,Button } from 'reactstrap'
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { layoutModeTypes } from "../../Components/constants/layout";
import store1 from "../../assets/images/store1.jpg" 
import logoDark from "../../assets/images/logo-dark.png"; 
import Layout from '../../Layouts/index';
import { ToastContainer, toast } from 'react-toastify';
import { getOEMListOpen,favorite,removeFavorite,baseURL } from '../../utils/oem';

const SearchInput = memo(({ onSearch }) => {
    const [localSearchContent, setLocalSearchContent] = useState('');

    const handleLocalSearch = () => {
        onSearch(localSearchContent);
    };

    return (
        <InputGroup className="search-input-group">
            <Input 
                value={localSearchContent} 
                onChange={(e) => setLocalSearchContent(e.target.value)}
                className="form-control search-input" 
                placeholder="Look for a store..." 
                onKeyPress={(e) => e.key === 'Enter' && handleLocalSearch()}
            />
            <button 
                className="btn btn-success search-btn" 
                type="button" 
                onClick={handleLocalSearch}
            >
                <i className="ri-search-2-line"></i>
            </button>
        </InputGroup>
    );
});

const HomePage = () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    const categories = [
       "All", "Entertainment", "Finance", "Retail", "Local", "Services", 
       "Travel", "Experiences", "Automotive", "Luxury", "Food & Beverage", 
       "Technology", "Preloved", "See All"
   ];
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(8); 
    const [companys, setcompanys] = useState([]); 
    const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
    const [loading, setLoading] = useState(true);

    const handleSearch = useCallback((searchValue) => { 
        setCurrentPage(1);
        loadOemData(1, null, searchValue);
    }, []);

    const viewMore = () => {
       setItemsPerPage(100);
       setCurrentPage(1);
       setTimeout(() => {
           loadOemData(1, null, null);
       }, 0);
    }
    const loadOemData = async (page, category, searchValue) => {
        try { 
            const param = {
                category: category,
                page: page,
                per_page: itemsPerPage,
                search: searchValue
            };
            const response = await getOEMListOpen(param);
            console.log(response); 
             
            if (response.status==200) {
                setcompanys(response.data.data);
                setTotalPages(response.data.total_pages);
            }else {
                errornotify(response.data.message)  
            }
            } catch (error) {
                 
            errornotify(error.message) 
            } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        loadOemData(1);
    }, []);
    const  handlePageChange = (page) => {
        setCurrentPage(page);
        console.log(page);
        loadOemData(page);
    }; 
    
    document.title = "Exia - Explore a world of storefronts";
    const HomeConter = () => {
       
        const handleFavorite = async(storeId,is_favorite) => {
            try { 
                  
                if(is_favorite){
                    const response = await removeFavorite(storeId);
                    if(response.status==200){
                        loadOemData(1) 
                    } 
                    else {
                        errornotify(response.message)
                    }
                    
                }else {
                    const response = await favorite(storeId);
                    if(response.status==200){
                        loadOemData(1)
                    }else {
                        errornotify(response.message)
                    }
                } 
              } catch (error) {
                errornotify(error.message)  
              }  
        };
        
        
        if (loading) {
            return <div className="text-center mt-5"><Spinner /> Loading companys...</div>;
        }
        return (
            <div className='page-content'>
            <Row className="hero-section justify-content-center align-items-center mb-3"> {/* 添加垂直居中和最小高度 */}     
                        <Col xs="10" xxs="12" className="py-4">
                        <div  className='head-content'  > 
                            <h1 className="mb-3" style={{color:'white'}}>Explore a world of storefronts.</h1>
                            <div className="mb-4">
                               <span style={{color:'white'}}> A more personalized way of finding your favourite stores and brands.</span></div>
                            <button className="btn btn-success homepage-btn-1">SHOP NOW</button>
                        </div>
                        </Col> 
                    </Row> 
                    <Row className='justify-content-center'> {/* 修正为 Bootstrap 标准水平居中类 */}
                        <Col xs="10" xxs="12" className="mx-auto"> {/* 添加自动边距实现二次居中 */}
                            <Row className='justify-content-between align-items-center mb-3'>
                                <Col xs="10">
                                    <SearchInput onSearch={handleSearch} />
                                </Col>
                                <Col xs="2">
                                <i className='bx bx-slider fs-22'></i>
                                </Col>
                            </Row>

                            <Row className="categories">
                                {categories.map((category, index) => ( 
                                        <button 
                                            key={index}
                                            onClick={() => loadOemData(1, category)} 
                                            className="btn w-auto homepage-btn m-2"
                                        >
                                            {category}
                                        </button>
                                ))}
                            </Row>

                            <Row className='mb-5 mt-5 align-item-content'>
                                <Col>
                                    <h2>Popular Storefronts</h2>
                                </Col>
                                <Col className='d-flex justify-content-end' xs="auto">
                                    <span style={{ cursor: 'pointer' }}  onClick={() => viewMore()} className="align-self-center"><h3>View all</h3></span>
                                </Col>
                            </Row>

                            <Row className='mb-5'>
                                {companys.map((store) => (
                                    <Col key={store.id} xl={3} lg={4} md={6} sm={6} xs={12} className='mb-3'>
                                      <Card className="h-100 p-0 store-card" style={{borderRadius:'25px',boxShadow:'0px 4px 4px 0px rgba(0, 0, 0, 0.25)'}}>
                                          <CardBody className="p-0" style={{borderRadius:'25px'}}>
                                            <div style={{ position: 'relative',textAlign:'center' }}>
                                                        <img src={store.storefront_image?`${baseURL}/file/oem/image/${store.storefront_image}` :store1} 
                                                             alt={store.oem_companyname} 
                                                             className="img-fluid store-image" 
                                                             style={{borderRadius:'25px 25px 0 0',height:'200px',width:'100%'}}
                                                        />
                                                        <i 
                                                           className={`ri-heart-${store.made_favorite_by && store.made_favorite_by.includes(user?.id) ? 'fill' : 'line'} fs-4`}
                                                            style={{ 
                                                                position: 'absolute', 
                                                                top: '10px', 
                                                                right: '10px', 
                                                                cursor: 'pointer',
                                                                color: store.made_favorite_by && store.made_favorite_by.includes(user?.id) ? 'red' : 'white' 
                                                            }}
                                                            onClick={() => user?.id && handleFavorite(store.id, store.made_favorite_by?.includes(user.id))}
                                                        />
                                                    </div>
                                                    
                                                    <Link to={`/product-list?company_id=${store.id}`} className="store-link">
                                                    <Row className="card-content mt-2 align-items-center mx-0">
                                                        <Col className="text-start">
                                                            <h5 className="mb-0 store-title">{store.oem_companyname}</h5>
                                                        </Col>
                                                        <Col className="text-end">
                                                            <div className="d-flex align-items-center justify-content-end">
                                                                <i className="ri-heart-line ms-1"></i>
                                                                <span className="ms-1">{store.made_favorite_by.length}</span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    </Link>
                                                </CardBody>
                                            </Card>
                                    </Col>
                                ))}
                            </Row>
                            {companys.length > 0 && (
                                <Row className="mt-4 mb-4">
                                <Col sm={12} className="text-center">
                                    <Button 
                                        disabled={currentPage === 1} 
                                        onClick={() =>{
                                            handlePageChange(currentPage - 1) 
                                        } }
                                    >
                                        Previous
                                    </Button>
                                    <span className="mx-3">
                                        Page {currentPage} of {totalPages}
                                    </span>
                                    <Button 
                                        disabled={currentPage === totalPages} 
                                        onClick={() => {
                                            handlePageChange(currentPage + 1) 
                                        }}
                                    >
                                        Next
                                    </Button>
                                </Col>
                            </Row>
                            )}
                        </Col>
                    </Row> 
            </div>
        ) 
    }
    return (
        <React.Fragment>
            {/* <div className="page-content"> */}
            <div>
            {user?<Layout ><HomeConter/></Layout>:<Container fluid> 
                <Row className="hero-section justify-content-center align-items-center mb-3"> {/* 添加垂直居中和最小高度 */}        
                        <Col xs="10" xxs="12">
                            <div className="navbar-header">  
                                <Link to="/home" className={`logo logo-dark`} style={{marginRight:'50px'}}> 
                                    <span className="logo-lg">
                                        <img src={logoDark } alt="" height="40" />
                                    </span>
                                </Link> 
                                <div className="d-flex align-items-center justify-content-between" style={{width:'100%'}}>
                                    <div>
                                        <Link to="/" className='home-link'>News</Link>
                                        <Link to="/" className='home-link'>Pricing</Link>
                                        <Link to="/" className='home-link'>About</Link>
                                        <Link to="/" className='home-link'>Exia+</Link>
                                    </div>
                                    <div>
                                    <Link className="btn btn-white" style={{marginRight:'10px'}}>SIGN UP</Link>
        
                                    <Link 
                                      to="/login" 
                                      state={{ from: "/home" }}  // 新增state参数
                                      className="btn  homepage-btn-1"
                                    >
                                      LOG IN
                                    </Link>
                                    </div>
                                </div>
                            </div>
                        </Col> 
                        <Col xs="10" xxs="12" className="py-4">
                        <div className="col-lg-6 col-md-8 col-sm-10"> 
                            <h1 className="mb-3" style={{color:'white'}}>Explore a world of storefronts.</h1>
                            <div className="mb-4">
                               <span style={{color:'white'}}> A more personalized way of finding your favourite stores and brands.</span></div>
                            <button className="btn btn-success homepage-btn-1">SHOP NOW</button>
                        </div>
                        </Col> 
                    </Row> 
                    <Row className='justify-content-center'> {/* 修正为 Bootstrap 标准水平居中类 */}
                        <Col xs="10" xxs="12" className="mx-auto"> {/* 添加自动边距实现二次居中 */}
                            <Row className='justify-content-between align-items-center mb-3'>
                                <Col xs="10">
                                    <SearchInput onSearch={handleSearch} />
                                </Col>
                                <Col xs="2">
                                <i className='bx bx-slider fs-22'></i>
                                </Col>
                            </Row>

                            <Row className="categories">
                                {categories.map((category, index) => ( 
                                        <button 
                                            key={index}
                                            onClick={() => loadOemData(1, category)} 
                                            className="btn w-auto homepage-btn m-2"
                                        >
                                            {category}
                                        </button>
                                ))}
                            </Row>

                            <Row className='mb-5 mt-5 align-item-content'>
                                <Col>
                                    <h2>Popular Storefronts</h2>
                                </Col>
                                <Col className='d-flex justify-content-end' xs="auto">
                                    <Link to="/view-all" className="align-self-center"><h3>View all</h3></Link>
                                </Col>
                            </Row>

                            <Row className='mb-5'>
                                {companys.map((store) => (
                                    <Col key={store.id} xl={3} lg={4} md={6} sm={6} xs={12} className='mb-5'>
                                            <Card className="h-100  p-0" style={{borderRadius:'25px',boxShadow:'0px 4px 4px 0px rgba(0, 0, 0, 0.25)'}}>
                                                <CardBody className="p-0" style={{borderRadius:'25px'}}> {/* 添加 p-0 类去除内边距 */}
                                                    <div style={{ position: 'relative',textAlign:'center' }}>
                                                        <img src={store.storefront_image?`${baseURL}/file/oem/image/${store.storefront_image}` :store1} alt={store.oem_companyname} className="img-fluid" style={{borderRadius:'25px 25px 0 0',height:'200px',width:'100%'}}/>
                                                        <i 
                                                           className={`ri-heart-${store.made_favorite_by && store.made_favorite_by.includes(user?.id) ? 'fill' : 'line'} fs-4`}
                                                            style={{ 
                                                                position: 'absolute', 
                                                                top: '10px', 
                                                                right: '10px', 
                                                                cursor: 'pointer',
                                                                color: store.made_favorite_by && store.made_favorite_by.includes(user?.id) ? 'red' : 'white' 
                                                            }}
                                                            onClick={() => user?.id && handleFavorite(store.id, store.made_favorite_by?.includes(user.id))}
                                                        />
                                                    </div>
                                                    
                                                    <Link to={`/product-list?category=${store.id}`} className="store-link">
                                                    <Row className="card-content mt-2 align-items-center mx-0"> {/* 添加 mx-0 移除水平外边距 */}
                                                        <Col className="text-start col-md-8">
                                                            <h5 className="mb-0">{store.oem_companyname}</h5>
                                                        </Col>
                                                        <Col className="text-end col-md-4">
                                                            <div className=" d-flex align-items-center justify-content-end">
                                                                <i className="ri-heart-line ms-1"></i>
                                                                <span className="ms-1">{store.made_favorite_by.length}</span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    </Link>
                                                </CardBody>
                                            </Card>
                                    </Col>
                                ))}
                            </Row>
                            {companys.length > 0 && (
                                <Row className="mt-4">
                                <Col sm={12} className="text-center">
                                    <Button 
                                        disabled={currentPage === 1} 
                                        onClick={() =>{
                                            handlePageChange(currentPage - 1) 
                                        } }
                                    >
                                        Previous
                                    </Button>
                                    <span className="mx-3">
                                        Page {currentPage} of {totalPages}
                                    </span>
                                    <Button 
                                        disabled={currentPage === totalPages} 
                                        onClick={() => {
                                            handlePageChange(currentPage + 1) 
                                        }}
                                    >
                                        Next
                                    </Button>
                                </Col>
                            </Row>
                            )}
                        </Col>
                    
                    
                    </Row> 

                    <div  className='bottom-content' >
                                       <span style={{ margin: 'auto 0' }}>Exia makes it possible for you to add your storefront too, with our Plus plan. 
                                       We even provide the hardware to get started.</span> 
                                        <Link to="/login" state={{ from: "/home" }}  className="btn btn-white" style={{ margin: 'auto 0' ,float: 'right'}}> SIGN UP NOW </Link>
                                    </div>
                </Container>}
            </div>
        </React.Fragment>
    )
}

export default HomePage